var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserReading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.47,
    height: 23.15,
    viewBox: "0 0 17.47 23.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-reading"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.4,4.2A3.44,3.44,0,0,1,11.8.8a3.37,3.37,0,0,1,3.4,3.4,3.37,3.37,0,0,1-3.4,3.4A3.44,3.44,0,0,1,8.4,4.2Zm.9,0a2.5,2.5,0,0,0,5,0,2.5,2.5,0,1,0-5,0Z",
    transform: "translate(-3.27 -0.45)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,11.7c0-1.5-2.1-2.6-4.8-2.6s-4.8,1.2-4.8,2.6c0,.2-.2.3-.4.3s-.5-.1-.5-.3c0-1.8,2.6-3.3,5.7-3.3s5.7,1.5,5.7,3.3c0,.2-.2.3-.5.3S16.8,11.9,16.8,11.7Z",
    transform: "translate(-3.27 -0.45)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.84,11.58a.85.85,0,0,1,.54.94c0,.78,0,1.56,0,2.34v.22h.1c.43.05.69.25.72.68a7.72,7.72,0,0,1,0,1.36c0,.45-.29.62-.82.69a1.27,1.27,0,0,0,0,.2v2.67a.73.73,0,0,1-.61.8l-6.64,1.6a.66.66,0,0,1-.28,0c-2.2-.52-4.4-1.06-6.6-1.59a.72.72,0,0,1-.63-.8V17.82H4.51a.68.68,0,0,1-.71-.66,7.28,7.28,0,0,1,0-1.4c0-.44.29-.61.82-.67v-.2c0-.79,0-1.57,0-2.36a.85.85,0,0,1,.54-.94H5.5l1.34.34c1.67.4,3.33.81,5,1.2a.69.69,0,0,0,.32,0l3.2-.78c.58-.14,1.17-.27,1.75-.42l1.39-.35ZM5,15.14l.07,0A1.31,1.31,0,0,1,6,16.44a1.34,1.34,0,0,1-.82,1.27.26.26,0,0,0-.11.2c0,.93,0,1.85,0,2.77,0,.28.08.37.36.44l6.17,1.49.26,0V13.53l-.17,0L9,12.85,5.51,12c-.3-.07-.49,0-.49.3C5,13.25,5,14.2,5,15.14Zm7.18,7.52.2,0,6.23-1.5c.29-.07.35-.16.35-.46,0-.91,0-1.82,0-2.73a.24.24,0,0,0-.16-.25,1.36,1.36,0,0,1,0-2.45l.17-.09c0-.9,0-1.8,0-2.71,0-.4-.14-.51-.53-.41l-4.71,1.13-1.54.38ZM4.13,16.48c0,.19,0,.36,0,.53s.17.42.48.41a1,1,0,0,0-.06-1.94.37.37,0,0,0-.42.37C4.14,16.07,4.14,16.28,4.13,16.48Zm15.74,0h0c0-.12,0-.25,0-.37a2.46,2.46,0,0,0,0-.26.38.38,0,0,0-.43-.37,1,1,0,0,0,0,1.94c.3,0,.43-.1.46-.39S19.86,16.66,19.87,16.48Z",
    transform: "translate(-3.27 -0.45)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.27 -0.45)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReading);
export default __webpack_public_path__ + "static/media/user-reading.e7b0359ab67a1380607f099aa3b41c78.svg";
export { ForwardRef as ReactComponent };